/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Resource sharing integration configuration
*/
export class DataShareIntegrationConfig {
  'lastSyncedAt'?: Date;
  /**
  * List of cloud-provider-assigned resource IDs to share with the integration. 
  */
  'resourceIds'?: Array<string>;
  'attachedResources'?: number;
  'status'?: string;
  'msg'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "lastSyncedAt",
      "baseName": "lastSyncedAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "resourceIds",
      "baseName": "resourceIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "attachedResources",
      "baseName": "attachedResources",
      "type": "number",
      "format": "int32"
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "string",
      "format": ""
    },
    {
      "name": "msg",
      "baseName": "msg",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DataShareIntegrationConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

